
import {map, catchError} from 'rxjs/operators';
import {Injectable} from "@angular/core";
import { ActivatedRouteSnapshot } from "@angular/router";
import {Observable, Subject, BehaviorSubject, of} from "rxjs";
import {PopulationRule} from "../../../../../../swaggerServices";
import {PopulationService} from "../../../../../../swaggerServices";

@Injectable()
export class PopulationRulesResolver {
  curPopulationRule: any;
  subject: Subject<PopulationRule | null> = new BehaviorSubject(null);

  constructor(private populationService: PopulationService) {
  }

  resolve(route: ActivatedRouteSnapshot) {
    const populationId = Number(route.paramMap.get('populationId'));
    return this.resolveForPopulation(populationId);
  }

  resolveForPopulation(populationId: number) {

    return this.populationService.getPopulationClientRules(populationId).pipe(
      catchError(() => of(null)),
      map(populationRule => {
        // @ts-ignore TODO - getPopulationClientRules has wrong return type. Swagger schema needs updating
        populationRule.populationClientRules.forEach(c => {

          // filter by tax year
          // @ts-ignore TODO - getPopulationClientRules has wrong return type. Swagger schema needs updating
          c.clientQuestions = c.clientQuestions.filter(q => q.year === populationRule.year);

          // handle order
          c.clientQuestions = c.clientQuestions.filter(q => q.order != null)
            .sort((a, b) => a.order - b.order)
            .concat(c.clientQuestions.filter(c => c.order == null));

          // sorts answer by id to get most recent answer
          c.clientQuestions.forEach(q => {
            q.clientAnswers.sort((a, b) => b.id - a.id);
          });
        });

        // @ts-ignore TODO - getPopulationClientRules has wrong return type. Swagger schema needs updating
        populationRule.populationClientRules =
          // @ts-ignore TODO - getPopulationClientRules has wrong return type. Swagger schema needs updating
          populationRule.populationClientRules.filter(c => c.clientQuestions.length > 0);

        this.curPopulationRule = populationRule;
        // @ts-ignore TODO - getPopulationClientRules has wrong return type. Swagger schema needs updating
        this.subject.next(populationRule);
        return populationRule;
      }),);

  }

  populationRule(): Observable<PopulationRule> {
    return this.subject;
  }

}
